import localeZh from '@angular/common/locales/zh';
import localeZhExtra from '@angular/common/locales/extra/zh';

import { LanguageEnum, Language } from '../core/interfaces/language-types';

export default class ChineseLanguage extends Language {
  protected locale = localeZh;
  protected localeExtra = localeZhExtra;
  protected details = {
    image: 'images/flags/zh.png',
    title: 'Chinese',
    enum: LanguageEnum.Chinese,
    aira: 'Chinese Selected',
    select: 'Choose Chinese Language',
    abre: 'zh'
  };
}
